import { Box, BoxProps, Link, LinkProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PropsWithChildren } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface BoxWrapperProps extends BoxProps {
  disabled: boolean;
}

const BoxWrapper = styled(Box)<BoxWrapperProps>(({ theme, disabled }) => ({
  display: 'flex',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
    textDecorationColor: theme.palette.state.linkHover,
    color: theme.palette.state.linkHover,
  },
  ...(disabled && {
    a: {
      /* color: theme.palette.text.disabled, */
      opacity: '0.38',
    },
    'svg > path': {
      /* stroke: theme.palette.text.disabled, */
      opacity: '0.38',
    },
    pointerEvents: 'none',
  }),
}));

const RouterLinkWrapper = styled(RouterLink)<LinkProps>(({ theme }) => ({
  fontSize: '1.125rem',
  fontStyle: 'normal',
  lineHeight: '1.625rem',
  color: theme.palette.state.linkHover,
  textDecoration: 'none',
}));

const LinkWrapper = styled(Link)<LinkProps>(({ theme }) => ({
  fontSize: '1.125rem',
  fontStyle: 'normal',
  lineHeight: '1.625rem',
  color: theme.palette.state.linkHover,
  textDecoration: 'none',
}));

interface ClickableLinkWithIconProps extends PropsWithChildren, LinkProps {
  onClick: (params?: unknown) => unknown;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  to?: string;
  target?: string;
  disabled?: boolean;
  wrapperSx?: BoxProps['sx'];
}

function ClickableLinkWithIcon({
  children,
  leftIcon,
  rightIcon,
  onClick,
  to,
  target,
  disabled = false,
  wrapperSx,
  ...rest
}: ClickableLinkWithIconProps) {
  return (
    <BoxWrapper sx={wrapperSx} onClick={onClick} disabled={disabled}>
      {leftIcon ? <Box sx={{ paddingRight: '0.5rem', display: 'flex', alignItems: 'center' }}>{leftIcon}</Box> : null}
      {to ? (
        <RouterLinkWrapper sx={rest.sx} className={rest.className} to={to} target={target || '_self'}>
          {children}
        </RouterLinkWrapper>
      ) : (
        <LinkWrapper {...rest}>{children}</LinkWrapper>
      )}
      {rightIcon ? <Box sx={{ paddingLeft: '0.5rem', display: 'flex', alignItems: 'center' }}>{rightIcon}</Box> : null}
    </BoxWrapper>
  );
}

export default ClickableLinkWithIcon;
